import { AlertTriangle, CheckCircle2 } from "lucide-react";

/** Is training possible? (Replicate token present — credit is checked by Replicate when a run starts.) */
export default function ReplicateBanner({ status }) {
  if (!status) return null;
  if (!status.connected) {
    return (
      <div data-testid="replicate-banner-missing" className="flex items-start gap-3 rounded-2xl border border-rose-400/25 bg-rose-500/10 px-4 py-3 text-[13px] text-rose-100">
        <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
        <span>Replicate isn't connected, so training and previews are switched off. You can still add and clean your recordings.</span>
      </div>
    );
  }
  return (
    <div data-testid="replicate-banner-ok" className="flex items-start gap-3 rounded-2xl border border-cyan-300/20 bg-cyan-300/[0.06] px-4 py-3 text-[13px] text-cyan-50/90">
      <CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-cyan-300" />
      <span>Replicate is connected. Training and previews run on your Replicate account and are billed there by GPU time — keep some credit on it (replicate.com → Account → Billing).</span>
    </div>
  );
}
